/**
 * Checks if a given time falls within the range of a schedule item
 * @param currentTime - The time slot to check (e.g., "09:15")
 * @param startTime - The start time of the schedule item (e.g., "09:00")
 * @param endTime - The end time of the schedule item (e.g., "12:00")
 * @returns true if currentTime is within the range [startTime, endTime)
 */
export const isTimeWithinRange = (currentTime: string, startTime: string, endTime: string): boolean => {
  // Convert time strings to minutes for easier comparison
  const timeToMinutes = (time: string): number => {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  };

  const currentMinutes = timeToMinutes(currentTime);
  const startMinutes = timeToMinutes(startTime);
  const endMinutes = timeToMinutes(endTime);

  // Check if current time is within the range [start, end)
  // Activities should show ONLY in time slots where they are actually running
  // NOT in the time slot where they end
  return currentMinutes >= startMinutes && currentMinutes < endMinutes;
};

/**
 * Formats a duration in minutes to a human-readable string
 * @param minutes - The duration in minutes
 * @returns Formatted string (e.g., "2h 30m", "45m", "3h", or "N/A")
 */
export const formatDuration = (minutes: number | null | undefined): string => {
  if (!minutes) return 'N/A';
  const hours = Math.floor(minutes / 60);
  const mins = Math.round(minutes % 60);
  if (hours === 0) return `${mins}m`;
  if (mins === 0) return `${hours}h`;
  return `${hours}h ${mins}m`;
};
